import {MutationTree} from 'vuex'
import {MutationTypes} from './types'
import {ICompaniesStateModel} from './../../../interfaces'
import {CompanyModel, CompaniesListSortModel, CompaniesListFilterModel} from '@/services/types'

export type CompaniesMutations<S = ICompaniesStateModel> = {
    [MutationTypes.SET_COMPANIES_LIST](state: S, payload: CompanyModel []): void;
    [MutationTypes.SET_COMPANIES_LIST_PAGE](state: S, payload: number ): void;
    [MutationTypes.SET_COMPANIES_LIST_PER_PAGE](state: S, payload: number ): void;
    [MutationTypes.SET_COMPANIES_TOTAL](state: S, payload: number ): void;
    [MutationTypes.SET_COMPANIES_DATA_IS_LOADING](state: S, payload: boolean ): void;
    [MutationTypes.SET_COMPANIES_SORT_VALUE](state: S, payload: CompaniesListSortModel ): void;
    [MutationTypes.SET_COMPANIES_FILTER_VALUE](state: S, payload: CompaniesListFilterModel ): void;
    [MutationTypes.SET_COMPANIES_SELECTED_COMPANY](state: S, payload: CompanyModel ): void;
}

export const mutations: MutationTree<ICompaniesStateModel> & CompaniesMutations = {
    [MutationTypes.SET_COMPANIES_LIST](state, payload: CompanyModel []) {
        state.list = payload
    },
    [MutationTypes.SET_COMPANIES_LIST_PAGE](state, payload: number ) {
        state.page = payload
    },
    [MutationTypes.SET_COMPANIES_LIST_PER_PAGE](state, payload: number ) {
        state.perPage = payload
    },
    [MutationTypes.SET_COMPANIES_TOTAL](state, payload: number ) {
        state.total = payload
    },
    [MutationTypes.SET_COMPANIES_DATA_IS_LOADING](state, payload: boolean ) {
        state.dataIsLoading = payload
    },
    [MutationTypes.SET_COMPANIES_SORT_VALUE](state, payload: CompaniesListSortModel ) {
        state.sort = payload
    },
    [MutationTypes.SET_COMPANIES_FILTER_VALUE](state, payload: CompaniesListFilterModel ) {
        state.filter = payload
    },
    [MutationTypes.SET_COMPANIES_SELECTED_COMPANY](state, payload: CompanyModel ) {
        state.selectedCompany = payload
    }
}